import type { OfferPreview } from "../api/offerPreview";

type Line = OfferPreview["lines"][number];
export const isRegularPosition = (line: Line) => !line.source_note && !line.alternative && !line.optional && line.inclusion !== "excluded" && line.inclusion !== "unknown";
export const isGoodsPosition = (line: Line) => line.position_kind === undefined || line.position_kind === "goods";
export const isComparablePosition = (line: Line) => isRegularPosition(line) && isGoodsPosition(line);
export const goodsKind = (line: Line) => line.position_kind === "goods" ? "Ware" : line.position_kind === "service" ? "Dienstleistung" : line.position_kind === "information" ? "Information" : line.position_kind === "unknown" ? "Positionsart offen" : "";
export function positionKind(line: Line): string {
  if (line.position_kind) return [goodsKind(line), line.alternative ? "Alternative" : "", line.optional ? "optional" : ""].filter(Boolean).join(" · ");
  if (line.alternative && line.optional) return "Alternative · optional";
  if (line.alternative) return "Alternative";
  if (line.optional) return "Optionalartikel";
  return "Reguläre Position";
}

export const positionCurrency = (line: Line, preview: OfferPreview) => line.currency !== undefined ? line.currency : preview.currency;

export const offerRole = (preview: OfferPreview) => preview.supplier_role === "manufacturer" ? "Hersteller" : preview.supplier_role === "manufacturer_direct" ? "Hersteller/Direktlieferant" : "Großhändler";
export const salesChannel = (preview: OfferPreview) => preview.sales_channel === "wholesale_explicit" ? "Vertrieb über Großhandel laut PDF" : "Vertriebsweg im PDF nicht angegeben";
